import axios from 'axios'

const baseUrl = 'api/ipnode'
const baseUrlEntity = 'api/entities'
const baseUrlInventor = 'api/inventor'
const baseUrlPatentDetails = 'api/patents'
const baseUrlConcept = 'api/concept'

let patentDetailsController = null

export function getPatentList(nodeParams, tableParams) {
    return axios.post(`${baseUrl}/patents`, nodeParams, {
        params: tableParams,
    })
}

export function getPatentListIPBasics(entityPK, basicParams, tableParams) {
    return axios.post(`${baseUrlEntity}/${entityPK}/patents`, basicParams, {
        params: tableParams,
    })
}

export function getLitPatentList(nodePk, tableParams) {
    return axios.get(`${baseUrl}/${nodePk}/litigation/patents`, {
        params: tableParams,
    })
}

export function getPatentDetails(patentId) {
    if (patentDetailsController) {
        patentDetailsController.abort()
    }

    if (patentId === null) {
        return
    }

    patentDetailsController = new AbortController()

    return axios.get(`api/patents/${patentId}`, {
        signal: patentDetailsController.signal,
    })
}

export function getPatentListInventor(params, tableParams) {
    let url = `${baseUrlInventor}/${params.inventorPk}`
    if (params.entityPk) {
        url += `/entity/${params.entityPk}`
    }
    url += '/patents'
    return axios.get(url, {
        params: tableParams,
    })
}

export function getSimilarPatents(publicationPk, entityPK = null) {
    const params = {
        maxResults: 5,
    }
    if (entityPK) {
        params.entityPk = entityPK
    }

    return axios.get(`${baseUrlPatentDetails}/${publicationPk}/similar_patents`, {
        params: params,
    })
}

export function runProductMapping(publicationPk, entityPK = null) {
    const params = {}
    if (entityPK) {
        params.entityPk = entityPK
    }

    return axios.get(`${baseUrlPatentDetails}/${publicationPk}/product_filing_history`, {
        params: params,
    })
}

export function getAISummary(publicationPk) {
    return axios.get(`${baseUrlPatentDetails}/${publicationPk}`)
}

export function getConceptIntersectionPatentList(conceptPks, entityPks, tableParams) {
    return getConceptPatentList(conceptPks, entityPks, 'intersection', tableParams)
}

export function getConceptDirectPatentList(conceptPks, entityPks, tableParams) {
    return getConceptPatentList(conceptPks, entityPks, 'direct', tableParams)
}

function getConceptPatentList(conceptPks, entityPks, queryType, tableParams) {
    const request = {
        conceptPks,
        entityPks,
        queryType,
    }

    return axios.post(`${baseUrlConcept}/patent`, request, { params: tableParams })
}
